<template>
  <BaseLocationInput
    :model-value="modelValue"
    :label="label"
    :help-text="helpText"
    :hide-label="hideLabel"
    autocomplete-type="address"
    @update:model-value="handleModelValueUpdate"
    @place-selected="handlePlaceSelected"
  />
</template>

<script setup>
import { ref } from 'vue';
import BaseLocationInput from './BaseLocationInput.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: 'Location',
  },
  helpText: {
    type: String,
    required: false,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
});

function handleModelValueUpdate(value) {
  emit('update:modelValue', value);
}

function handlePlaceSelected(item) {
  emit('update:modelValue', item.description);
}
</script>
